
export const SpecialHandlingIndMappingConstant = {
    Table: {
        PRIORITY: "Priority",
        SPECIAL_HANDLING_CODE: "SP Handling Code",
        SPECIAL_HANDLING_IND: "SP Handling Ind.",
        ACTIVE_IND: "Active Ind.",
    },
    Title: {
        CATEGORY: "Charge",
        TITLE: "SP Handling Indicator Setting",
    },
}
export const specialHandlingIndMappingRequiredFieldList: string[] = [
    'specialHandlingCodeList',
    'specialHandlingInd',
    'activeInd',
];